import Immutable from 'seamless-immutable';

import {
  PAGE_TYPE_CHANGE,
  RECEIVE_SEARCH_RESPONSE,
  REQUEST_SEARCH,
  RESET_FACET_GROUP,
  TOGGLE_FACET_CHOSEN,
  TOGGLE_FACET_GROUP_SHOW_MORE,
  TOGGLE_FACETS,
  TOGGLE_SELECTED_FACET,
  TOGGLE_SELECTED_FACET_GROUP, TOGGLE_SIZING_FACET_GROUP
} from 'constants/reduxActions';
import {
  BEST_FOR_YOU_FACETFIELD,
  SINGLE_SELECT_FILTERS
} from 'constants/appConstants';
import { FILTERS_RE } from 'common/regex';
import marketplace from 'cfg/marketplace.json';

const { search: { onlyOneGroupOpen, topBrands, sizeFacetFields, suppressFiltersLinkHrefs, hasCollapsedSizes } } = marketplace;

const initialState = {
  toDisplay: [],
  chosenFacetGroup: null,
  requestedUrl: null,
  mobileFacetSortToggled: false,
  sizingFacetGroupToggled: true,
  navigation: {
    sizing: [],
    core: [],
    zEverythingElse: []
  }
};

const sizeFacets = [
  'hc_women_size',
  'hc_women_width',
  'hc_men_size',
  'hc_men_width',
  'hc_footwear_infant_toddler_youth_size',
  'hc_kids_width'
];

export function isFacetsVisible(state = false, action) {
  const { type, visible, pageType } = action;
  switch (type) {
    case TOGGLE_FACETS:
      return visible;
    case PAGE_TYPE_CHANGE:
      return pageType === 'search' ? state : false;
    default:
      return state;
  }
}

export const sortTopBrands = facet => {
  if (facet.facetField === 'brandNameFacet' && topBrands?.length > 0) {
    const facetValuesCopy = [ ...facet.values ];
    const foundTopValues = facetValuesCopy.filter((v, i) => {
      const foundIndex = topBrands.indexOf(v.name.toLowerCase()) > -1;
      if (foundIndex) {
        facetValuesCopy.splice(i, 1);
        return foundIndex;
      }
    }).sort((a, b) => topBrands.indexOf(a.name) - topBrands.indexOf(b.name));
    facet.values = foundTopValues.concat(facetValuesCopy);
  }
};

export const stripSeoSuppressedUrls = (facets, seoSuppressedUrls = suppressFiltersLinkHrefs) => {
  const mapFacetValues = seoSuppressedUrls ? facet => ({
    ...facet, values: facet.values.map(value => {
      const { facetUrl } = value;
      return FILTERS_RE.test(facetUrl) ? { ...value, facetUrl: null } : value;
    })
  }) : facet => facet;

  return facets.map(facet => {
    topBrands.length > 0 && sortTopBrands(facet);
    return mapFacetValues(facet);
  });
};

const makePersonalizedSizeInfo = sizes => ` (${sizes[0]}-${sizes[sizes.length - 1]})`;

export default function facets(state = initialState, action) {
  const { type, isFresh, selectedFacetGroupIndex, selectedFacetGroupName, selectedFacetIndex, response, url, isPcm, section, hydraSizingAssist, hydraPills, hydraNewSearchNav } = action;
  let newState = Immutable(state);

  switch (type) {
    case TOGGLE_SELECTED_FACET_GROUP:
    {
      // TODO: Remove or swap logic when hssa is permanent
      if ((hydraSizingAssist || hydraPills || hydraNewSearchNav) && section) {
        Object.keys(newState.navigation).map(section => {
          (newState.navigation[section] || []).map((group, index) => {
            const { facetField } = group;
            if (facetField === selectedFacetGroupName) {
              newState = newState.set('mobileFacetSortToggled', false);
              newState = newState.set('chosenFacetGroup', { section, ...group });
              newState = newState.updateIn(['navigation', section, index, 'isSelected'], v => (v ? false : 'selected'));
              newState = newState.updateIn(['navigation', section, index, 'desktopSelected'], v => (v ? false : 'selected'));
            }
          });
        });
      } else {
        const groupName = newState.pcm && newState.pcm.findIndex(f => f.facetField === selectedFacetGroupName) > -1 ? 'pcm' : 'toDisplay';
        const index = (newState[groupName] || []).findIndex(facet => facet.facetField === selectedFacetGroupName);

        if (selectedFacetGroupName === 'sort') {
          newState = newState.set('mobileFacetSortToggled', !newState.mobileFacetSortToggled);
          newState = newState.set('chosenFacetGroup', initialState.chosenFacetGroup);
          newState = newState.updateIn([groupName, index, 'isSelected'], () => false);
        }

        if (index > -1) {
          newState = newState.set('mobileFacetSortToggled', false);
          newState = newState.set('chosenFacetGroup', !newState.chosenFacetGroup || (onlyOneGroupOpen && newState.chosenFacetGroup?.facetField !== selectedFacetGroupName) ? newState[groupName][index] : initialState.chosenFacetGroup);
          newState = newState.updateIn([groupName, index, 'isSelected'], v => (v ? false : 'selected'));
          newState = newState.updateIn([groupName, index, 'desktopSelected'], v => (v ? false : 'selected'));
        }
      }
      return newState;
    }
    case TOGGLE_SELECTED_FACET:
    {
      // TODO: Remove or swap logic when hssa is permanent
      if ((hydraSizingAssist || hydraPills || hydraNewSearchNav) && section) {
        const facet = newState['navigation'][section][selectedFacetGroupIndex];
        if (facet) {
          if (SINGLE_SELECT_FILTERS[facet.facetField]) {
            // chosen facet is a single-select, so remove the group from the tree
            // since only 1 item should be selected from a single-select at a time.
            newState = newState.updateIn(['navigation', section], items => items.filter((item, i) => i !== selectedFacetGroupIndex));
            newState = newState.set('chosenFacetGroup', initialState.chosenFacetGroup);
          } else {
            newState = newState.updateIn(['navigation', section, selectedFacetGroupIndex, 'values', selectedFacetIndex, 'isSelected'], v => !v);
          }
        }
      } else {
        const facetGroupName = isPcm ? 'pcm' : 'toDisplay';
        const facet = newState[facetGroupName][selectedFacetGroupIndex];
        if (facet) {
          if (SINGLE_SELECT_FILTERS[facet.facetField]) {
            // chosen facet is a single-select, so remove the group from the tree
            // since only 1 item should be selected from a single-select at a time.
            newState = newState.update(facetGroupName, items => items.filter((item, i) => i !== selectedFacetGroupIndex));
            newState = newState.set('chosenFacetGroup', initialState.chosenFacetGroup);
          } else {
            newState = newState.updateIn([facetGroupName, selectedFacetGroupIndex, 'values', selectedFacetIndex, 'isSelected'], v => !v);
          }
        }
      }
      return newState;
    }
    case REQUEST_SEARCH:
      if (isFresh) {
        newState = Immutable(initialState);
      }
      return newState.set('requestedUrl', url);
    case RECEIVE_SEARCH_RESPONSE:
      if (response.url === state.requestedUrl) {
        const filters = response.filters || {};
        const hasZc1AndGender = filters?.zc1 && filters?.txAttrFacet_Gender;

        newState = newState.update('toDisplay', () => stripSeoSuppressedUrls(response.facets));

        if (newState.toDisplay && newState.toDisplay.length > 0) {
          let allFacets = newState.toDisplay;
          // TODO: Remove or swap logic when hssa is permanent
          if (response.navigation) {
            if (hydraPills || hydraNewSearchNav) {
              newState = newState.set('navigation', response.navigation);
            } else if (hydraSizingAssist && response.navigation.sizing) {
              const newNav = { sizing: response.navigation.sizing };
              newState = newState.set('navigation', newNav);
            } else {
              newState = newState.set('navigation', initialState.navigation);
            }

            // Filter sizes out of facets
            allFacets = newState.toDisplay.filter(t => !newState.navigation?.sizing.some(n => n.facetField === t.facetField));

            if (hasCollapsedSizes && response.navigation?.sizing && hasZc1AndGender && newState.sizingFacetGroupToggled) {
              newState = newState.set('sizingFacetGroupToggled', !newState.sizingFacetGroupToggled);
            }

            for (const section in newState.navigation) {
              const newSection = newState.navigation[section].map(facetGroup => {
                const { facetField } = facetGroup;
                const newFacetGroup = { ...facetGroup };
                if (hasCollapsedSizes && !hasZc1AndGender && section === 'sizing') {
                  let result = 'selected';
                  for (const prevFacet of state.navigation.sizing) {
                    if (prevFacet.facetField === facetGroup.facetField && !prevFacet.desktopSelected) {
                      result = false;
                    }
                  }
                  newFacetGroup.showMore = false;
                  newFacetGroup.desktopSelected = result;
                }
                newFacetGroup.values = facetGroup.values.map(facetValue => {
                  const newValue = { ...facetValue };
                  if (FILTERS_RE.test(facetValue.facetUrl)) {
                    newValue.facetUrl = null;
                  }

                  if (!facetValue.displayName) {
                    newValue.displayName = facetValue.name;
                  }

                  if (filters[facetField] && filters[facetField].indexOf(facetValue.name) > -1) {
                    newValue.isSelected = true;
                  }

                  return newValue;
                });
                return newFacetGroup;
              });
              newState = newState.setIn(['navigation', section], newSection);
            }

            const sizeKey = newState.navigation?.sizing.filter(v => sizeFacetFields.includes(v.facetField));
            if (response.customerPreferences && sizeKey.length) {
              const sizeMessage = `${response.customerPreferences.facets[0].name}${makePersonalizedSizeInfo(response.customerPreferences.sizes)}`;
              const personalizedFacet = { facetField: BEST_FOR_YOU_FACETFIELD, facetFieldDisplayName: 'Your Preferences', values: [{ count: null, name: sizeMessage, displayName: sizeMessage, confidence: 1 }] };
              const newFacets = [ personalizedFacet, ...newState.navigation.sizing ];
              newState = newState.setIn(['navigation', 'sizing'], newFacets);
            }
          }

          if (!hydraPills || !hydraNewSearchNav) {
            const newFacets = allFacets.map(v => {
              if (hasCollapsedSizes && sizeFacets.includes(v.facetField) && !hasZc1AndGender) {
                v = v.update('desktopSelected', () => {
                  let check = 'selected';
                  for (const prevFacet of state.toDisplay) {
                    if (prevFacet.facetField === v.facetField && !prevFacet.desktopSelected) {
                      check = false;
                    }
                  }
                  return check;
                });
              }

              v = v.set('values', v.values.map(g => {
                /*
                  Display value for facets
                  https://github01.zappos.net/mweb/marty/issues/6307
                */
                if (!g.displayName) {
                  g = g.set('displayName', g.name);
                }

                if (filters[v.facetField] && filters[v.facetField].indexOf(g.name) > -1) {
                  g = g.set('isSelected', true);
                }
                return g;
              }));
              return v;
            });
            newState = newState.set('toDisplay', newFacets);
            const sizeKey = response.facets.filter(v => sizeFacetFields.includes(v.facetField));
            if ((!hydraSizingAssist && !hydraPills && !hydraNewSearchNav) && response.customerPreferences && sizeKey.length) {
              const sizeMessage = `${response.customerPreferences.facets[0].name}${makePersonalizedSizeInfo(response.customerPreferences.sizes)}`;
              const personalizedFacet = { facetField: BEST_FOR_YOU_FACETFIELD, facetFieldDisplayName: 'Your Preferences', values: [{ count: null, name: sizeMessage, displayName: sizeMessage, confidence: 1 }] };
              const newFacets = [ personalizedFacet, ...newState.toDisplay ];
              newState = newState.set('toDisplay', newFacets);
            }
          }
        }
      }

      return newState;
    case TOGGLE_FACET_GROUP_SHOW_MORE:
      const currentVal = newState.navigation[section][selectedFacetIndex].showMore;
      newState = newState.setIn(['navigation', section, selectedFacetIndex, 'showMore'], !currentVal);
      return newState;
    case TOGGLE_FACET_CHOSEN:
      newState = newState.set('chosenFacetGroup', initialState.chosenFacetGroup);
      return newState;
    case TOGGLE_SIZING_FACET_GROUP:
      newState = newState.set('sizingFacetGroupToggled', !newState.sizingFacetGroupToggled);
      return newState;
    case RESET_FACET_GROUP:
      // TODO: Remove or swap logic when hssa is permanent
      if (hydraSizingAssist || hydraPills) {
        Object.keys(newState.navigation).forEach(section => {
          newState.navigation[section].forEach((v, i) => {
            newState.navigation[section][i].values.forEach((g, ii) => {
              if (newState.navigation[section][i].values[ii].isSelected) {
                newState = newState.setIn(['navigation', section, i, 'values', ii, 'isSelected'], false);
              }
            });
          });
          newState = newState.set('chosenFacetGroup', initialState.chosenFacetGroup);
        });
      }
      newState.toDisplay.forEach((v, i) => {
        newState.toDisplay[i].values.forEach((g, ii) => {
          if (newState.toDisplay[i].values[ii].isSelected) {
            newState = newState.setIn(['toDisplay', i, 'values', ii, 'isSelected'], false);
          }
        });
      });
      newState = newState.set('chosenFacetGroup', initialState.chosenFacetGroup);

      return newState;
    default:
      return state;
  }
}
